export default {
    ACCEPT_ALL: 'ACCEPT_ALL',
    ACCEPT_SELECTED: 'ACCEPT_SELECTED',
}
